import { calculateTrueSolarTime } from './lib/trueSolar';

const form = document.querySelector<HTMLFormElement>('[data-solar-form]');
const output = document.querySelector<HTMLElement>('[data-solar-output]');
const error = document.querySelector<HTMLElement>('[data-solar-error]');

function signed(value: number) {
  return `${value >= 0 ? '+' : '−'}${Math.abs(value).toFixed(1)} min`;
}

function windowLabel(index: number) {
  const labels = ['Early Zi (00:00–00:59)', 'Chou (01:00–02:59)', 'Yin (03:00–04:59)', 'Mao (05:00–06:59)', 'Chen (07:00–08:59)', 'Si (09:00–10:59)', 'Wu (11:00–12:59)', 'Wei (13:00–14:59)', 'Shen (15:00–16:59)', 'You (17:00–18:59)', 'Xu (19:00–20:59)', 'Hai (21:00–22:59)', 'Late Zi (23:00–23:59)'];
  return labels[index] || 'Unknown';
}

function render() {
  if (!form || !output || !error) return;
  error.textContent = '';
  const data = new FormData(form);
  try {
    const date = String(data.get('date') || '');
    const time = String(data.get('time') || '');
    const longitude = Number(data.get('longitude'));
    const timezoneOffsetHours = Number(data.get('offset'));
    const result = calculateTrueSolarTime({ date, time, longitude, timezoneOffsetHours });
    const civilHour = Number(time.slice(0, 2));
    const civilMinute = Number(time.slice(3, 5));
    const civilSeconds = civilHour * 3600 + civilMinute * 60;
    const civilIndex = civilSeconds >= 23 * 3600 ? 12 : civilSeconds < 3600 ? 0 : Math.floor((civilSeconds + 3600) / 7200);
    output.innerHTML = `
      <div class="asset-result-main"><span>TRUE SOLAR TIME</span><strong>${result.correctedDate}<br>${result.correctedTime}</strong><p>${result.dayOffset === 0 ? 'Same civil date' : result.dayOffset > 0 ? 'Shifted to the next date' : 'Shifted to the previous date'}</p></div>
      <dl class="asset-result-grid">
        <div><dt>Equation of time</dt><dd>${signed(result.equationOfTimeMinutes)}</dd></div>
        <div><dt>Longitude correction</dt><dd>${signed(result.longitudeCorrectionMinutes)}</dd></div>
        <div><dt>Total correction</dt><dd>${signed(result.totalCorrectionMinutes)}</dd></div>
        <div><dt>Traditional window</dt><dd>${windowLabel(result.timeIndex)}</dd></div>
      </dl>
      <p class="asset-boundary ${civilIndex !== result.timeIndex ? 'is-changed' : ''}">${civilIndex !== result.timeIndex ? 'Boundary changed: the corrected time falls in a different two-hour window.' : 'Boundary unchanged: civil and corrected times stay in the same two-hour window.'}</p>`;
    output.hidden = false;
  } catch (caught) {
    error.textContent = caught instanceof Error ? caught.message : 'Please check the input values.';
    output.hidden = true;
  }
}

form?.addEventListener('submit', (event) => {
  event.preventDefault();
  render();
});

render();
